<template>
  <div class="gpt-work-order-info">
    <!-- 电商返款 进度 -->
    <div v-if="extendInfo.statusCount.all <= 10">
      <div v-if="extendInfo.statusCount.all == 0">主人，您<span class="y-f-b">{{extendInfo.chatParams.dateRange.dateStr}}</span>暂无电商返款订单。</div>
      <div v-else>主人，您<span class="y-f-b">{{extendInfo.chatParams.dateRange.dateStr}}</span>有<span class="y-f-b"> {{extendInfo.statusCount.all}} </span>个 <span class="y-fc-FF860E">{{extendInfo.chatParams.status || ''}}</span> 返款订单。
        <span v-if="extendInfo.statusCount['10']"><span class="y-fw-bold">{{refundType['10'].name}}</span> <span class="y-fc-FF860E">{{extendInfo.statusCount['10']}}</span> 个，</span>
        <span v-if="extendInfo.statusCount['20']"><span class="y-fw-bold">{{refundType['20'].name}}</span> <span class="y-fc-FF860E">{{extendInfo.statusCount['20']}}</span> 个，</span>
        <span v-if="extendInfo.statusCount['30']"><span class="y-fw-bold">{{refundType['30'].name}}</span> <span class="y-fc-35A921">{{extendInfo.statusCount['30']}}</span> 个，</span>
        <span v-if="extendInfo.statusCount['40']"><span class="y-fw-bold">{{refundType['40'].name}}</span> <span class="y-fc-gray">{{extendInfo.statusCount['40']}}</span> 个，</span>
        <span v-if="extendInfo.statusCount['50']"><span class="y-fw-bold">{{refundType['50'].name}}</span> <span class="y-fc-FD0206">{{extendInfo.statusCount['50']}}</span> 个，</span>
        申请后无特殊情况7个工作日到账。
      </div>
      <div class="split-line" v-if="extendInfo.page&&extendInfo.page.length"></div>
      <div v-for="(item, idx) in (extendInfo.page || [])" :key="idx" class="y-fl-40">
        <div class="y-f y-f-a y-f-jb" :class="{'y-mt-20': idx != 0}">
          <div class="y-f y-f-a y-f-js y-fl-h y-f-1 s-td">
            <span class="y-mr-10">{{item.mallName}}</span>
            <svg-icon v-if="item.platformCode" :iconClass="PLATFORMICONMAP[item.platformCode]" class="seller-icon"></svg-icon>
          </div>
          <div>
            <span class="process-status" :class="{'refund-back-color': getStausColor(item.checkStatusName)==1, 'refund-green-color': getStausColor(item.checkStatusName)==2, 'refund-gray-color': getStausColor(item.checkStatusName)==3}">
              <span>{{item.checkStatusName}}</span>
            </span>
          </div>
        </div>
        <div class="y-f y-f-a y-f-jb y-jb-baseline y-mt-10 y-fs-28" >
          <div class="y-w-180 y-f-shrink">
            <span class="y-fw-bold">返款单号：</span>
          </div>
          <div class="y-fc-gray">
            <span>{{item.refundCode}}</span>
          </div>
        </div>
        <div class="y-f y-f-a y-f-jb y-jb-baseline y-mt-10 y-fs-28" >
          <div class="y-w-180 y-f-shrink">
            <span class="y-fw-bold">返款金额：</span>
          </div>
          <div class="y-fc-gray">
            <span>{{item.paymentAmount}} 元</span>
          </div>
        </div>
        <div class="y-f y-f-a y-f-jb y-jb-baseline y-mt-10 y-fs-28" v-if="item.remark">
          <div class="y-w-180 y-f-shrink">
            <span class="y-fw-bold">驳回原因：</span>
          </div>
          <div class="y-fc-FD0206">
            <span>{{item.remark }}</span>
          </div>
        </div>
        <div class="split-line" v-if="idx != extendInfo.page.length - 1"></div>
      </div>
      <div class="split-line"></div>
      <div class="y-t-ac"><span class="nouse-text-btn" @click="viewRefundRuleFn">查看返款规则</span></div>
    </div>
    <div v-else>
      <div>主人，您<span class="y-f-b">{{extendInfo.chatParams.dateRange.dateStr}}</span>有 <span class="y-f-b y-fc-151719">{{extendInfo.statusCount.all}}个</span> <span class="y-fc-FF860E">{{extendInfo.chatParams.status || ''}}</span> 返款订单， 其中：</div>
      <div v-if="extendInfo.statusCount['10']" class="y-fw-bold  y-mt-12"><span>{{refundType['10'].name}}</span> <span class="y-fc-FF860E">{{extendInfo.statusCount['10']}} 个</span></div>
      <div v-if="extendInfo.statusCount['20']" class="y-fw-bold y-mt-12"><span>{{refundType['20'].name}}</span> <span class="y-fc-FF860E">{{extendInfo.statusCount['20']}} 个</span></div>
      <div v-if="extendInfo.statusCount['30']" class="y-fw-bold y-mt-12"><span>{{refundType['30'].name}}</span> <span class="y-fc-35A921">{{extendInfo.statusCount['30']}} 个</span></div>
      <div v-if="extendInfo.statusCount['40']" class="y-fw-bold y-mt-12"><span>{{refundType['40'].name}}</span> <span class="y-fc-gray">{{extendInfo.statusCount['40']}} 个</span></div>
      <div v-if="extendInfo.statusCount['50']" class="y-fw-bold y-mt-12"><span>{{refundType['50'].name}}</span> <span class="y-fc-FD0206">{{extendInfo.statusCount['50']}} 个</span></div>
      <!-- <div class="y-mt-20">数据量大，请在web端进行查看。</div> -->
      <div class="split-line"></div>
      <div class="y-f y-f-a y-f-jb" >
        <div class="y-t-ac y-bw-50"><span class="nouse-text-btn" @click="goRefundPageFn">查看明细</span></div>
        <div class="y-t-ac y-bw-50"><span class="nouse-text-btn" @click="viewRefundRuleFn">查看返款规则</span></div>
      </div>      
    </div>
  </div>
</template>
<script>
import { PLATFORMICONMAP } from "@/utils/globalConfig";
export default {
  props: {
    extendInfo: {
      type: Object
    },
  },
  components: {
    input_content: () => import('./showInputContent.vue')
  },
  data() {
    return {
      PLATFORMICONMAP,
      refundType: {
        'all': {
          name: '',
        },
        '10': {
          name: '待审核',
        },
        '20': {
          name: '返款中',
        },
        '30': {
          name: '已返款',
        },
        '40': {
          name: '已撤回',
        },
        '50': {
          name: '已驳回',
        }
      },
    }
  },
  mounted() {
    this.extendInfo.page = this.extendInfo.page || [];
    this.extendInfo.chatParams = this.extendInfo.chatParams || {};
    this.extendInfo.statusCount = this.extendInfo.statusCount || {};
    console.log(this.extendInfo)
    this.$nextTick(()=>{
      // 滚动轴往上顶
      this.$emit('scrollFn');
    })
  },
  methods: {
    getStausColor(status) {
      let colorCode = '';
      switch(status) {
        case '已驳回':
          colorCode = 1;
          break;
        case '已返款':
          colorCode = 2;
          break;
        case '已撤回':
          colorCode = 3;
          break;
        default:
          colorCode = ''
      }
      return colorCode;
    },
    // 查询返款规则
    viewRefundRuleFn(){
      this.$emit('viewRefundRule', '查看返款规则');
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = this.changeDate(date.getDate());
      return Y + M + D;
    },
    changeDate(t) {
      if (t < 10) {
          return "0" + t;
      } else {
          return t;
      }
    },
    // 查看明细
    goRefundPageFn() {
      let searchparams = this.extendInfo.chatParams.dateRange;
      let startDate = searchparams.startTime ? this.timestampToTime(searchparams.startTime) : '';
      let endDate = searchparams.endTime ? this.timestampToTime(searchparams.endTime) : '';
      let form = { activeIndex: 2, startDate, endDate, fromPage: 'gpt' };
      if(this.$route.name == 'activityTwo') {
        // 就在当前页
        this.bus.$emit(`activityTwo`, form);
      } else {
        // 不在当前页
        this.$router.push({ name: 'activityTwo', params:  form});
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../styles/variables";
.gpt-work-order-info {
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  .process-status {
    font-size: 12px;
    color: #FF723D;
    background-color: #fff2e6;
    padding: 0 8px;
    display: inline-block;
    text-align: center;
    border-radius: 8px;
  }
  .refund-back-color {
    color: #FD0206;
    background-color: rgba(253,2,6,0.1);
  }
  .refund-green-color {
    color: #35A921;
    background-color: #eaf6e8;
  }
  .refund-gray-color {
    color: #151719;
    background-color: #d9dbdf;
  }
  .y-fs-28 {
    font-size: 14px;
  }
  .y-fl-40 {
    line-height: 20px;
  }
  .y-f-shrink {
    flex-shrink: 0;
  }
  .y-jb-baseline {
    align-items: baseline;
  }
  .y-w-160 {
    width: 80px;
  }
  .y-w-180 {
    width: 100px;
  }
  .y-fc-gray {
    color: rgba(21,23,25,0.59);
  }
  .y-fl-h {
    line-height: 16px;
  }
  .y-ml-10 {
    margin-left: 5px;
  }
  .y-mt-12 {
    margin-top: 12px;
  }
  .split-line {
    width: 100%;
    height: 1px;
    background: #E4E4E4;
    margin-top: 8px;
    margin-bottom: 12px;
  }
  .nouse-text-btn {
    display: inline-block;
    margin: 0 auto;
    color: $blue-style;
    font-weight: 500;
    cursor: pointer;
  }
  .y-bw-50 {
    width: 50%;
  }
  .y-fc-151719 {
    color: #151719;
  }
  .y-fc-FF860E{
    color: #FF860E;
  }
  .y-fc-35A921{
    color: #35A921;
  }
  .y-fc-FD0206 {
    color: #FD0206;
  }
  .y-fw-bold {
    font-weight: 500;
  }
  .s-td {
    word-break: break-all;
  }
  .seller-icon {
    height: 18px;
    width: 18px;
  }
}

</style>
